import React from "react";
import CTable from "components/common/Table";
import { withRouter } from "react-router";
import Button from "components/common/Button";
import RequestDrawer from "./RequestDrawer";
const Connector = ({ data, loading, vehicledrawerOpen, toggleDrawer,response,handleOnChange }) => {
  const dummyData4 = [
    { id: 1, type: "AC", name: "250 Kw - Dc Level 3" },
    { id: 2, type: "DC", name: "250 Kw - Chademo 3" },
    { id: 3, type: "DC", name: "250 Kw - CSS 3" },
    { id: 4, type: "AC", name: "250 Kw - Dc Level 3" },
  ];
  const columns = [
    {
      field: "name",
      headerName: (
        <>
          <span>Customer name</span>
          
        </>
      ),
    },

    {
      field: "mobile",
      headerName: (
        <>
          <span>Charging station </span>
         
        </>
      ),
    },
    {
      field: "type",
      headerName: (
        <>
          <span>Type</span>
         
        </>
      ),
    },

    {
      field: "Connnector",
      headerName: (
        <>
          <span>Connector</span>
         
        </>
      ),
    },
    {
      field: "data",
      headerName: (
        <>
          <span>Data</span>
         
        </>
      ),
    },
    {
      field: "chnarging-time",
      headerName: (
        <>
          <span>Charging Time</span>
         
        </>
      ),
    },
    {
      field: "Unit-charge",
      headerName: (
        <>
          <span>Unit Charge</span>
        
        </>
      ),
    },
    {
      field: "amount",
      headerName: (
        <>
          <span>Amount</span>
         
        </>
      ),
    },
    {
      field: "action",
      headerName: "Action",
      valueGetter: (v, d) => {
      
        return (
          <>
            {
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  height: "25px",
                }}
              >
             
                <Button
                  style={{ fontSize: "13px" }}
                  variant="contained"
                  onClick={() => toggleDrawer(true)}
                >
                  {" "}
                  Respond
                </Button>
             
              </div>
            }
          </>
        );
      },
    },
  ];

  return (
    <>
      <CTable
        columns={columns}
        data={dummyData4}
        isLoading={loading?.isLoading}
        pagination={true}
        localPagination={true}
        page={0}
        rowsPerPage={5}
      ></CTable>
      <RequestDrawer
      response={response}
        toggleDrawer={toggleDrawer}
        drawerOpen={vehicledrawerOpen}
        handleOnChange={handleOnChange}
      />
    </>
  );
};

export default withRouter(Connector);
